<div class="flex flex-row">
    <a routerLink="/cart" routerLinkActive="active-link">
        CART
    </a>
    <ion-badge color="secondary" class="relative bottom-1 right-0.5" style="z-index: -1">{{ count() }}</ion-badge>
</div>
